<div class="form_sections mb-3">
  <h6><u>Declaration</u></h6>
  <mat-checkbox [(ngModel)]="declarationAccepted">
    I/We declare that, to the best of my/our knowledge and belief, the vehicles listed below and the information
    provided about them is true, complete and accurate.
  </mat-checkbox>
  <div class="invalid-feedback d-block" *ngIf="declarationTouched && !declarationAccepted">
    Please confirm the declaration.
  </div>
</div>

<!-- Declaration questions: answering these pre-fills the matching field on every
     vehicle below, so the common case needs no per-vehicle repetition. -->
<div class="form_sections mb-3">
  <p class="mb-3"><strong>TIP:</strong> select to default all of your answers.</p>

  <div class="row align-items-center py-2 border-bottom"
    *ngFor="let q of declarationQuestions">
    <div class="col-md-8">
      {{ q.text }}
      <a class="ml-2" title="{{ q.help }}" *ngIf="q.help"><i class="mdi mdi-information-outline"></i></a>
    </div>
    <div class="col-md-4">
      <mat-radio-group class="row" [(ngModel)]="q.answer" (change)="applyDeclarationAnswer(q)">
        <div class="col-6"><div class="quote_radio w-90"><mat-radio-button value="Yes">Yes</mat-radio-button></div></div>
        <div class="col-6"><div class="quote_radio w-90"><mat-radio-button value="No">No</mat-radio-button></div></div>
      </mat-radio-group>
    </div>
  </div>

  <p class="mt-3 mb-0"><small>These answers are applied to every vehicle below. You can still change any
    individual vehicle afterwards.</small></p>
</div>

<mat-accordion>
  <div class="form_sections" *ngFor="let vehicle of vehicles; let i = index">
    <mat-expansion-panel [expanded]="i === 0 || expandAll">
      <mat-expansion-panel-header>
        <mat-panel-title>
          <h4>
            <u>
              <span *ngIf="!vehicle.registration_number">Vehicle {{i + 1}}</span>
              <span *ngIf="vehicle.registration_number">{{vehicle.registration_number | uppercase}}</span>
              <span *ngIf="vehicle.type"> &mdash; {{vehicle.type | titlecase}}</span>
              <span *ngIf="!vehicle.registration_number && vehicle.make"> &mdash; {{vehicle.make}}</span>
            </u>
            <a (click)="removeVehicle(i); $event.stopPropagation()" title="Remove Vehicle"
              class="btn btn-danger btn-sm p-1 ml-3" *ngIf="vehicles.length > 1">
              <i class="mdi mdi-delete"></i>
            </a>
          </h4>
        </mat-panel-title>
      </mat-expansion-panel-header>

      <app-ag-vehicle-form
        [vehicle]="vehicle"
        [staticData]="staticData"
        [authDetails]="authDetails"
        [modelObj]="modelObj"
        [index]="i"
        (driverAdded)="onDriverAdded($event)"
        (driverRemoved)="onDriverRemoved($event)">
      </app-ag-vehicle-form>

    </mat-expansion-panel>
  </div>
</mat-accordion>

<div class="row mt-2">
  <div class="col-md-6">
    <a (click)="addVehicle()" class="btn btn-default btn-gray btn-sm">
      <i class="mdi mdi-plus"></i> Add Another Vehicle
    </a>
  </div>
</div>

<div class="row mt-4 mb-3">
  <div class="col-md-6">
    <button class="btn btn-secondary btn-sm" (click)="prevTab()">Previous</button>
  </div>
  <div class="col-md-6 text-right">
    <button class="btn btn-success btn-sm" (click)="nextTab()">Proceed</button>
  </div>
</div>
